var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.displayTooltip)?_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"id":"date-display","title":_vm.timezone}},[_vm._v(" "+_vm._s(_vm.formattedDate)+" ")]):_c('span',{attrs:{"id":"date-display-relative"}},[_vm._v(" "+_vm._s(_vm.formattedDate)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }